/**
 * Sea Route API — fetch maritime route coordinates from backend (searoute).
 * Returns [lat, lng][] and distance_km for Leaflet Polyline.
 */

import { apiPost } from "./api-client";

export interface SeaRouteParams {
    originLat: number;
    originLng: number;
    destinationLat: number;
    destinationLng: number;
}

export interface SeaRouteResult {
    coordinates: [number, number][];
    distance_km: number;
}

export async function fetchSeaRoute(
    params: SeaRouteParams,
    signal?: AbortSignal
): Promise<SeaRouteResult> {
    const data = await apiPost<SeaRouteResult>(
        "/sea-route/calculate",
        {
            origin_lat: params.originLat,
            origin_lng: params.originLng,
            destination_lat: params.destinationLat,
            destination_lng: params.destinationLng,
        },
        { signal }
    );
    return data;
}
